import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filter: {
        search: '',
        From: '',
        To: '',
    },
    categoryFilter: "",
    attachmentTypeFilter: "",
    statusFilter: "",
    page: 1,
}

const templatesSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        setSearch: (state, action) => {
            state.filter.search = action.payload.search;
        },
        setFrom: (state, action) => {
            state.filter.From = action.payload.From;
        },
        setTo: (state, action) => {
            state.filter.To = action.payload.To;
        },
        setCategoryFilter: (state, action) => {
            state.categoryFilter = action.payload;
        },
        setAttachmentTypeFilter: (state, action) => {
            state.attachmentTypeFilter = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        resetTemplatesFilter: (state) => {
            state.filter = initialState.filter;
            state.categoryFilter = initialState.categoryFilter;
            state.attachmentTypeFilter = initialState.attachmentTypeFilter;
            state.statusFilter = initialState.statusFilter;
            state.page = initialState.page;
        }
    }
});

export const {
    setSearch,
    setData,
    setFrom,
    setTo,
    setCategoryFilter,
    setAttachmentTypeFilter,
    setStatusFilter,
    setPage,
    resetTemplatesFilter
} = templatesSlice.actions;

export default templatesSlice.reducer;